export default "__VITE_ASSET__BxXQUAGU__"